import React from 'react';
import Icon from '../../../components/AppIcon';

const ErrorSummary = ({ errors, currentStep }) => {
  const errorCount = Object.keys(errors).length;
  
  if (errorCount === 0) return null;

  // Friendly field name mapping
  const fieldNameMap = {
    businessVertical: 'Business Vertical',
    companyName: 'Company Name',
    countryOrigin: 'Country of Origin',
    incorporationCertificate: 'Incorporation Certificate',
    contactPersonName: 'Contact Person Name',
    designation: 'Designation',
    email: 'Email',
    phoneNumber: 'Phone Number',
    website: 'Website',
    yearEstablished: 'Year Established',
    businessDescription: 'Business Description',
    registeredAddress: 'Registered Address',
    registeredCity: 'Registered City',
    registeredState: 'Registered State',
    registeredDistrict: 'Registered District',
    registeredCountry: 'Registered Country',
    registeredPincode: 'Registered Pincode',
    supplyAddress: 'Supply Address',
    supplyCity: 'Supply City',
    supplyState: 'Supply State',
    supplyDistrict: 'Supply District',
    supplyCountry: 'Supply Country',
    supplyPincode: 'Supply Pincode',
    bankName: 'Bank Name',
    branchName: 'Branch Name',
    accountNumber: 'Account Number',
    confirmAccountNumber: 'Confirm Account Number',
    accountType: 'Account Type',
    ifscCode: 'IFSC Code',
    swiftCode: 'Swift Code',
    bankAddress: 'Bank Address',
    bankProof: 'Bank Proof Document',
    annualTurnover: 'Annual Turnover',
    commodityCode: 'Commodity Code',
    msmeStatus: 'MSME Status',
    msmeCategory: 'MSME Category',
    msmeNumber: 'UDYAM Registration Number',
    msmeCertificate: 'MSME Certificate',
    msmeDeclaration: 'MSME Declaration',
    classificationYear: 'Classification Year',
    classificationDate: 'Classification Date',
    vendorType: 'Vendor Type',
    industrySector: 'Industry Sector',
    employeeCount: 'Employee Count',
    certifications: 'Certifications',
    preferredCurrency: 'Preferred Currency',
    taxRegistrationNumber: 'Tax Registration Number',
    panNumber: 'PAN Number',
    gstNumber: 'GST Number',
    vatNumber: 'VAT Number',
    cinNumber: 'CIN Number',
    gtaRegistration: 'GTA (Goods Transport Agency) Registration',
    specialCertifications: 'Special Certifications',
    dataPrivacyConsent: 'Data Privacy Consent',
    termsConditions: 'Terms & Conditions',
    codeOfConduct: 'Code of Conduct',
    ethicsDeclaration: 'Ethics Declaration',
    complianceAcknowledgment: 'Compliance Acknowledgment',
  };

  const getStepName = (step) => {
    const stepNames = {
      1: 'Company Information',
      2: 'Address Details',
      3: 'Bank Information',
      4: 'Categorization',
      5: 'Compliance',
      6: 'Agreements'
    };
    return stepNames[step] || `Step ${step}`;
  };

  return (
    <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 rounded-md shadow-sm">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <Icon name="AlertCircle" className="h-6 w-6 text-red-600" />
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-semibold text-red-800">
            {errorCount === 1 
              ? 'Please fix the following error to continue:' 
              : `Please fix the following ${errorCount} errors to continue:`
            }
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <ul className="list-disc list-inside space-y-1">
              {Object.entries(errors).map(([field, message]) => (
                <li key={field} className="leading-relaxed">
                  <span className="font-medium">{fieldNameMap[field] || field}:</span>{' '}
                  <span className="text-red-600">{message}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-3 text-xs text-red-600 font-medium">
            <Icon name="Info" className="inline h-4 w-4 mr-1" />
            Scroll down to see the highlighted fields that need correction.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorSummary;

